import { WaitingRoomConcluida } from "@pages/producto/credito_simple/tofu_v2/WaitingRoomConcluida";

/**
 * Salas de espera del wizard v2 propias de una empresa, por tenant. Igual que
 * `registroDatosPersonalesPorEmpresa`: si el tenant no está aquí se usa `WaitingRoom` (genérica).
 *
 * TODO: la sala de espera que debe ir es `WaitingRoomTimeline` (pasos SAT, Buró, cálculo de oferta), pero
 * falta definir sus pasos y estatus; mientras tanto se usa la genérica.
 */
export const waitingRoomPorEmpresa: Record<string, React.FC> = {
  // Marketplace (Pymio): la solicitud queda en el marketplace para las financieras aliadas.
  market_place: WaitingRoomConcluida,
};
